<template>
  <div class="table table--vertical">
    <table class="table__inner">
      <thead class="table__thead">
        <tr class="table__tr">
          <th class="table__th">Полное имя</th>
          <th class="table__th">Почта / UID</th>
          <th class="table__th">Роль</th>
        </tr>
      </thead>

      <tbody class="table__tbody">
        <tr
          class="table__tr"
          v-if="permissions?.length"
          v-for="permission in permissions"
          :key="permission.id"
        >
          <td class="table__td" data-title="Полное имя">
            {{ permission.fullname || "Неиндексированный пользователь" }}
          </td>
          <td class="table__td" data-title="Почта / UID">
            {{ permission.email || permission.user_id }}
          </td>
          <td class="table__td" data-title="Роль">
            {{ permission.text_role }}
            <a @click="emit('delete', permission.id)">
              <img class="icon icon--danger icon--sm" src="~images/close.svg" v-svg-inline/>
            </a>
          </td>
        </tr>
        <tr class="table__tr" v-else>
          <td class="table__td table__td--empty" colspan="4">
            Права доступа не найдены. Необходимо добавить права доступа.
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script setup>
defineProps({
  permissions: Array,
})

const emit = defineEmits(['delete'])
</script>